/**
 * PayPal environment detection and configuration
 */
import { PayPalEnvironment } from '@/features/billing/shared/types';

/**
 * Detect if we're in production environment
 */
export function detectProductionEnvironment(): boolean {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('192.168.');
  const isDevelopment = hostname.includes('staging') || hostname.includes('dev') || hostname.includes('test');
  const isProduction = hostname === 'swaysuite.com' || hostname === 'www.swaysuite.com' || hostname.endsWith('.swaysuite.com');

  console.log('PayPal Environment Detection:', {
    hostname,
    isLocalhost,
    isDevelopment,
    isProduction
  });

  return isProduction;
}

/**
 * Get PayPal client ID based on environment
 */
export function getPayPalClientId(isProduction: boolean): string {
  return isProduction
    ? import.meta.env.VITE_PAYPAL_CLIENT_ID_LIVE || ''
    : import.meta.env.VITE_PAYPAL_CLIENT_ID || '';
}

/**
 * Get current environment info
 */
export function getEnvironmentInfo(): { environment: PayPalEnvironment; clientId: string; isProduction: boolean; hostname: string } {
  const isProduction = detectProductionEnvironment();
  const clientId = getPayPalClientId(isProduction);

  return {
    environment: isProduction ? 'production' : 'sandbox',
    clientId: clientId ? `${clientId.substring(0, 8)}...` : 'Not configured',
    isProduction,
    hostname: window.location.hostname
  };
}